<template>
  <main class="gc-page">
    <section class="blog-carousel">
      <div
        class="carousel-track"
        :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
      >
        <!-- Slide 1: Video -->
        <div class="carousel-slide">
          <video
            ref="carouselVideo"
            class="slide-video"
            autoplay
            muted
            loop
            playsinline
            preload="auto"
          >
            <source
              src="https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/xin/Guy-with-Car_rev2_b.mp4"
              type="video/mp4"
            >
          </video>
          <div class="slide-overlay"></div>
          <div class="slide-content">
            <p class="slide-main-text">出行</p>
            <p class="slide-top-text">需要紧急帮助</p>
          </div>
        </div>

        <!-- Slide 2: Image -->
        <div class="carousel-slide">
          <img
            class="slide-image"
            src="https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/xin/Blog-Banner_2-scaled.jpg"
            alt=""
          >
          <div class="slide-overlay"></div>
        </div>
      </div>

      <!-- Arrows -->
      <button class="carousel-arrow carousel-prev" @click="prevSlide" aria-label="上一个">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
      </button>
      <button class="carousel-arrow carousel-next" @click="nextSlide" aria-label="下一个">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6"/>
        </svg>
      </button>

      <!-- Dots -->
      <div class="carousel-dots">
        <button
          v-for="i in slides"
          :key="i"
          class="carousel-dot"
          :class="{ active: (i - 1) === currentSlide }"
          @click="currentSlide = i - 1"
          :aria-label="'Slide ' + i"
        ></button>
      </div>
    </section>

    <section class="gc-section blog-intro" style="padding-top: 150px;">
      <div class="gc-container blog-intro-inner">
        <p class="blog-intro-text" style="font-size: 2rem;">
          探索故事、指南和见解，了解如何充分利用 <strong>19.9</strong>。
        </p>
        <div class="blog-hero-img">
          <img
            src="https://ziyuan-1358102587.cos.ap-guangzhou.myqcloud.com/waiguo/xin/GoodConnex-Conference-Meeting.png"
            alt="19.9 Conference"
          >
        </div>
        <h2 class="blog-big-title">简报</h2>
        <p class="blog-tagline"><strong>您的平台。您的社区。您的行动。</strong></p>
        <p class="blog-desc">
          欢迎来到 <strong>简报</strong> — <strong>19.9</strong> 官方社区公告板。
        </p>
      </div>
    </section>

    <section class="gc-section blog-article" style="padding-top: 0;">
      <div class="gc-container blog-article-inner">
        <p>这是您的实用见解、励志故事，以及让日常生活更轻松的真实策略中心。</p>
        <p>在这里，我们聚焦正在发展副业的邻居。</p>
        <p>我们分享关于更聪明赚钱的专家建议。</p>
        <p>我们探索塑造本地服务与社区连接未来的趋势。</p>
        <p>无论您是想增加收入、寻找可靠帮助，还是仅仅保持知情，简报 为您提供在快速变化的世界中茁壮成长的工具、理念和鼓励。</p>

        <h3 class="blog-section-title">日常工作零佣金时代的到来</h3>

        <p><strong>19.9</strong> 是一个去中心化、零佣金的平台，将普通人与本地服务连接起来——提供一种快速、灵活的方式，让您按自己的条件发布、匹配并赚取收益。</p>
        <p>我们以一条简单但有力的信念开启 简报：</p>
        <p class="blog-highlight"><strong>您应该保留自己赚到的每一分钱。</strong></p>
        <p>我们同样相信另一件同样重要的事：更强大的本地社区。</p>

        <h3 class="blog-section-title">一份目标宣言</h3>

        <p>我们看到了一个问题。大多数数字平台承诺"连接"人们，但最终却成了障碍。</p>
        <p>它们抽取你 20% 到 30% 的收入。</p>
        <p>它们限制你如何沟通。</p>
        <p>它们将小型服务者埋没在筛选器、费用和复杂规则之下。</p>
        <p>对于试图诚实谋生的自由职业者、零工和副业者来说，这种模式已破碎。所以我们打造了一些不同的东西——一个面向本地服务的现代版公告板。</p>
        <ul class="blog-list">
          <li>没有佣金</li>
          <li>没有微观管理</li>
          <li>没有平台干预</li>
        </ul>
        <p>只是一个发布你的服务或需求、直接连接的地方。</p>

        <h3 class="blog-section-title">四种运作方式（简单明了）</h3>

        <p><strong>19.9</strong> 的设计理念是直观、快速、公平。</p>
        <ol class="blog-list">
          <li>发布你能提供的服务，或你需要的帮助。</li>
          <li>在本地进行匹配。</li>
          <li>直接连接，自行商定条款。</li>
          <li>保留你赚到的每一分钱。</li>
        </ol>
        <p><strong>19.9</strong> 就是这么简单。无论你是提供辅导、维修、摄影、出行还是遛狗服务，你始终掌控全局。</p>

        <h3 class="blog-section-title">为什么是现在？</h3>

        <p>工作世界正在改变。人们正在重新思考如何赚钱、如何消费，以及谁从他们的努力中受益。副业正在崛起。点对点交易正在增长。社区希望有本地化的替代方案来替代企业把关人。</p>
        <p><strong>19.9</strong> 是这一转变的一部分。我们不只是又一个 App。我们是对灵活性、简单性和经济赋权需求的回应。</p>

        <h3 class="blog-section-title">在 简报 上你会发现什么</h3>

        <p>简报 将呈现：</p>
        <ul class="blog-list">
          <li>本地创业者与用户的聚焦故事</li>
          <li>推荐奖励和 App 更新</li>
          <li>发展副业的技巧</li>
          <li>寻找可靠本地帮助的实用建议</li>
          <li>塑造邻里服务未来的趋势</li>
        </ul>
        <p>我们将保持诚实、有用、以人为本，正如平台本身一样。</p>

        <h3 class="blog-section-title">想帮助我们成长？</h3>

        <p>你不必等待完美的时机。现在就行动起来。</p>
        <ul class="blog-list">
          <li>创建你的第一条发布，试试水温</li>
          <li>邀请一位可以增加收入的朋友</li>
          <li>把 <strong>19.9</strong> 分享给需要可靠帮助的人</li>
          <li>把你的故事发给我们。你可能会被推荐在这里</li>
        </ul>

        <h3 class="blog-section-title">最后的话</h3>

        <p><strong>19.9</strong> 是为了把权力还给真正做事的人。无论你是赚取额外收入、开启副业、寻找项目工作，还是只是帮助邻居，你都应该保留自己赚到的。</p>
        <p class="blog-section-title">但这不仅仅是为服务提供者准备的。</p>
        <p>如果你需要快速搭车去商店、修理家里的东西，或者需要平面设计等项目的帮助，你会发现 <strong>19.9</strong> 是一个快速、简单的解决方案。</p>
        <p>没有中间人。没有摩擦。只有结果。</p>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'bulletin-board',
  data() {
    return {
      currentSlide: 0,
      slides: 2,
      autoplayTimer: null
    }
  },
  methods: {
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.slides
    },
    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.slides) % this.slides
    },
    startAutoplay() {
      this.stopAutoplay()
      this.autoplayTimer = setInterval(() => {
        this.nextSlide()
      }, 5000)
    },
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer)
        this.autoplayTimer = null
      }
    }
  },
  mounted() {
    this.startAutoplay()
  },
  beforeUnmount() {
    this.stopAutoplay()
  }
}
</script>

<style scoped>
.blog-carousel {
  position: relative;
  width: 100%;
  height: 100vh;
  min-height: 560px;
  max-height: 900px;
  overflow: hidden;
}

.carousel-track {
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.carousel-slide {
  position: relative;
  min-width: 100%;
  height: 100%;
  overflow: hidden;
}

.slide-video,
.slide-image {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  transform: translate(-50%, -50%);
  object-fit: cover;
}

.slide-overlay {
  position: absolute;
  inset: 0;
  background: rgba(20, 28, 32, 0.45);
  z-index: 1;
}

.slide-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 40px 28px;
  text-align: center;
  color: #fff;
}

.slide-top-text {
  font-size: clamp(18px, 2.5vw, 28px);
  font-weight: 700;
  margin-bottom: 12px;
  text-shadow: 2px 2px 0 rgba(0, 0, 0, 0.25);
}

.slide-main-text {
  font-size: clamp(56px, 10vw, 120px);
  font-weight: 900;
  line-height: 1;
  text-shadow: 4px 5px 0 rgba(0, 0, 0, 0.3);
}

/* Arrows */
.carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 0;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
  backdrop-filter: blur(4px);
}

.carousel-arrow:hover {
  background: rgba(255, 255, 255, 0.35);
}

.carousel-arrow svg {
  width: 28px;
  height: 28px;
}

.carousel-prev {
  left: 20px;
}

.carousel-next {
  right: 20px;
}

/* Dots */
.carousel-dots {
  position: absolute;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
  display: flex;
  gap: 10px;
}

.carousel-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.7);
  background: transparent;
  cursor: pointer;
  transition: background 0.2s;
}

.carousel-dot.active {
  background: #fff;
  border-color: #fff;
}

/* Intro */
.blog-intro {
  background: #fff;
}

.blog-intro-inner {
  text-align: center;
}

.blog-intro-text {
 
  margin: 0 auto 48px;
  font-size: 19px;
  line-height: 1.7;
  color: #68717b;
}

.blog-intro-text strong {
  color: #1f2933;
}

.blog-hero-img {
  max-width: 880px;
  margin: 0 auto 52px;
  border-radius: 12px;
  overflow: hidden;
}

.blog-hero-img img {
  width: 100%;
  display: block;
}

.blog-big-title {
  font-size: clamp(52px, 7vw, 88px);
  font-weight: 900;
  color: #1f2933;
  line-height: 1.05;
  margin-bottom: 20px;
}

.blog-tagline {
  font-size: clamp(20px, 2.5vw, 28px);
  color: #1f2933;
  margin-bottom: 28px;
  line-height: 1.4;
}

.blog-tagline strong {
  font-weight: 800;
}

.blog-desc {
  max-width: 720px;
  margin: 0 auto;
  font-size: 18px;
  line-height: 1.7;
  color: #68717b;
}

.blog-desc strong {
  color: #1f2933;
}

/* Article */
.blog-article {
  background: #fff;
}

.blog-article-inner {
  text-align: left;
  max-width: 800px;
}

.blog-article-inner p {
  font-size: 18px;
  line-height: 1.8;
  color: #1f2933;
  margin-bottom: 16px;
}

.blog-article-inner p strong {
  font-weight: 800;
}

.blog-section-title {
  font-size: clamp(28px, 4vw, 40px);
  font-weight: 900;
  color: #1765b2;
  margin: 48px 0 24px;
  line-height: 1.15;
}

.blog-highlight {
  font-size: 20px !important;
  margin: 28px 0 !important;
}

.blog-highlight strong {
  font-weight: 900;
}

.blog-list {
  margin: 12px 0 24px;
  padding-left: 24px;
  font-size: 18px;
  line-height: 2;
  color: #1f2933;
}

.blog-list li {
  margin-bottom: 4px;
}

.blog-list strong {
  font-weight: 800;
}

@media (max-width: 780px) {
  .blog-carousel {
    min-height: 420px;
    max-height: 600px;
  }

  .carousel-arrow {
    width: 40px;
    height: 40px;
  }

  .carousel-arrow svg {
    width: 22px;
    height: 22px;
  }

  .carousel-prev {
    left: 10px;
  }

  .carousel-next {
    right: 10px;
  }

  .blog-article-inner p {
    font-size: 16px;
  }

  .blog-section-title {
    margin: 36px 0 18px;
  }
}
</style>
